var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12C17.8549 20.7606 16.6746 25.7555 25.9669 28.9032C19.7189 31.0508 18.8771 30.9129 16 37.6292C13.1668 31.0718 11.9701 30.8941 6.0331 28.9032C15.3254 25.7555 14.1451 20.7606 16 12Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8555 3C31.027 8.53299 29.9131 11.6877 36.1504 13.6757C32.2042 14.6636 31.6726 14.945 29.8555 19.1868C28.0661 15.0454 27.3102 14.5647 23.5606 13.6757C29.7978 11.6877 28.6839 8.53299 29.8555 3Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8555 21C38.5152 28.8384 37.3538 33.3076 45.7732 36.1239C40.1829 37.9402 39.4297 37.9221 36.8555 43.9314C34.3205 38.0643 33.2497 37.8 27.9377 36.1239C36.3571 33.3076 35.1958 28.8384 36.8555 21Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.87e6b6e1cbb8833e68c9e50b0b797a44.svg";
export { ForwardRef as ReactComponent };